import { Directive } from '@angular/core';

@Directive({ selector: '[calendarTableContent]' })
export class NgxCalendarTableContentDirective { }